/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon20Solid = forwardRef('CertRosetteAltIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a6.25 6.25 0 0 0-4 11.053v5.974a1 1 0 0 0 1.538.843L10 17.3l2.462 1.57A1 1 0 0 0 14 18.027v-5.975A6.25 6.25 0 0 0 10 1ZM6.25 7.25a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z" })));
});
